import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "voiceOverHeader"
};
const _hoisted_2 = {
  class: "voiceOverSubtitle"
};
const _hoisted_3 = {
  key: 1,
  class: "voiceOverHeader"
};
const _hoisted_4 = {
  class: "voiceOverSubtitle"
};
const _hoisted_5 = {
  key: 2,
  class: "voiceOverHeader"
};
const _hoisted_6 = {
  class: "voiceOverSubtitle"
};
const _hoisted_7 = {
  key: 3,
  class: "voiceOverHeader"
};
const _hoisted_8 = {
  class: "voiceOverSubtitle"
};
const _hoisted_9 = {
  key: 4,
  class: "voiceOverHeader"
};
const _hoisted_10 = {
  class: "voiceOverSubtitle"
};
const _hoisted_11 = {
  class: "voiceOverContainer"
};
const _hoisted_12 = {
  class: "voiceOverPlayer"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  key: 1,
  class: "countDownContainer"
};
const _hoisted_15 = {
  class: "buttonBar"
};
const _hoisted_16 = {
  key: 0,
  class: "steper"
};
const _hoisted_17 = {
  key: 1,
  class: "steper"
};
const _hoisted_18 = {
  key: 2,
  class: "steper"
};
const _hoisted_19 = {
  class: "labelVoiceAISelected"
};
const _hoisted_20 = {
  key: 3,
  class: "steper"
};
const _hoisted_21 = {
  key: 4,
  class: "steper vertical"
};
const _hoisted_22 = {
  class: "recordingProgressBar"
};
const _hoisted_23 = {
  class: "recordingBar"
};
const _hoisted_24 = {
  class: "recordingTime"
};
const _hoisted_25 = {
  key: 5,
  class: "steper"
};
const _hoisted_26 = {
  class: "restartContainer"
};
const _hoisted_27 = {
  key: 6,
  class: "steper txtEditing"
};
const _hoisted_28 = {
  class: "buttonBarTxtEdition"
};
const _hoisted_29 = {
  class: "comboBoxLang"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TitlePopUp = _resolveComponent("TitlePopUp");
  const _component_icon = _resolveComponent("icon");
  const _component_LegacyVideoChapterPlayer = _resolveComponent("LegacyVideoChapterPlayer");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_light_button = _resolveComponent("light-button");
  const _component_MediaRecorder = _resolveComponent("MediaRecorder");
  const _component_w_input = _resolveComponent("w-input");
  const _component_w_select = _resolveComponent("w-select");
  const _component_loader = _resolveComponent("loader");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_w_dialog, {
    visible: _ctx.voiceOverOpen,
    fullscreen: false,
    "append-to-body": true,
    customClass: 'voiceOverStudioPanel',
    modal: true,
    "close-on-outside-click": false,
    onOnDialogClose: _cache[7] || (_cache[7] = $event => _ctx.onClose()),
    width: 936
  }, {
    header: _withCtx(() => [_ctx.currentStep == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_TitlePopUp, null, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.panel.main.title')), 1)]),
      _: 1
    }), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('voiceOver.panel.main.subtitle')), 1)])) : _createCommentVNode("", true), _ctx.currentStep >= 10 && _ctx.currentStep < 20 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_TitlePopUp, null, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.panel.microphone.title')), 1)]),
      _: 1
    }), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('voiceOver.panel.microphone.subtitle')), 1)])) : _createCommentVNode("", true), _ctx.currentStep === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_TitlePopUp, null, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        class: "backIcon",
        icon: "chevron-left",
        onClick: _ctx.cancelVoiceAI
      }, null, 8, ["onClick"]), _createTextVNode(" " + _toDisplayString(_ctx.$t('voiceOver.panel.ai.title')), 1)]),
      _: 1
    }), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('voiceOver.panel.ai.subtitle')), 1)])) : _createCommentVNode("", true), _ctx.currentStep > 1 && _ctx.currentStep < 10 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_TitlePopUp, null, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.panel.subtitle.title')), 1)]),
      _: 1
    }), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('voiceOver.panel.subtitle.subtitle')), 1)])) : _createCommentVNode("", true), _ctx.currentStep >= 20 && _ctx.currentStep < 30 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_TitlePopUp, null, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.panel.text.title')), 1)]),
      _: 1
    }), _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('voiceOver.panel.text.subtitle')), 1)])) : _createCommentVNode("", true), !_ctx.isRecording ? (_openBlock(), _createElementBlock("div", {
      key: 5,
      class: "closeIcon",
      onClick: _cache[0] || (_cache[0] =
      //@ts-ignore
      (...args) => _ctx.closeVoiceOver && _ctx.closeVoiceOver(...args))
    }, [_createVNode(_component_icon, {
      icon: "close",
      size: "default"
    })])) : _createCommentVNode("", true)]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_LegacyVideoChapterPlayer, {
      ref: "videoPlayer",
      "url-player": _ctx.urlPlayer,
      autoplay: false,
      onOnPlay: _ctx.onPlay,
      onOnPause: _ctx.onStop,
      onOnDuration: _ctx.onDuration,
      onOnTimeUpdate: _ctx.onTimeUpdate,
      onOnVolumeChange: _ctx.onVolumeChange
    }, null, 8, ["url-player", "onOnPlay", "onOnPause", "onOnDuration", "onOnTimeUpdate", "onOnVolumeChange"]), _ctx.urlBlob ? (_openBlock(), _createElementBlock("audio", {
      key: 0,
      ref: "audioPlayer",
      src: _ctx.urlBlob
    }, null, 8, _hoisted_13)) : _createCommentVNode("", true), _ctx.currentStep == 10 && _ctx.countDown >= -1 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_withDirectives(_createElementVNode("div", {
      class: "textCountDown"
    }, _toDisplayString(_ctx.countDown), 513), [[_vShow, _ctx.countDown > 0]]), _createVNode(_Transition, {
      name: "fade"
    }, {
      default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
        class: "startCountDownMessage"
      }, _toDisplayString(_ctx.$t('voiceOver.record.go')), 513), [[_vShow, _ctx.countDown == 0]])]),
      _: 1
    })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, [_ctx.currentStep == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_w_tool_tip, {
      text: !_ctx.generateVoiceEnabled ? _ctx.$t('voiceOver.buttons.aiDisabledTooltip') : '',
      placement: "bottom"
    }, {
      default: _withCtx(() => [_createVNode(_component_standard_button, {
        class: "buttonRecord",
        disabled: !_ctx.generateVoiceEnabled,
        label: '',
        outlined: true,
        onAction: _ctx.onChooseAIVoice
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          icon: "creation-outline"
        }), _createTextVNode(" " + _toDisplayString(_ctx.$t('voiceOver.buttons.AIVoice')), 1)]),
        _: 1
      }, 8, ["disabled", "onAction"])]),
      _: 1
    }, 8, ["text"]), _cache[8] || (_cache[8] = _createElementVNode("div", {
      class: "spacer"
    }, null, -1)), _createVNode(_component_standard_button, {
      class: "buttonRecord",
      label: '',
      onAction: _ctx.onChooseMicVoice
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "record-circle-outline"
      }), _createTextVNode(" " + _toDisplayString(_ctx.$t('voiceOver.buttons.record')), 1)]),
      _: 1
    }, 8, ["onAction"])])) : _createCommentVNode("", true), _ctx.currentStep == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_icon, {
      icon: "chevron-left",
      class: "buttonBackVoiceAI",
      size: "medium",
      onClick: _cache[1] || (_cache[1] = $event => _ctx.currentStep = 0)
    }), _createVNode(_component_standard_button, {
      label: "",
      outlined: true,
      class: "buttonFromText",
      onAction: _ctx.selectGenerateWithText
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "pen",
        class: "iconPen"
      }), _createTextVNode(" " + _toDisplayString(_ctx.$t('voiceOver.buttons.withText')), 1)]),
      _: 1
    }, 8, ["onAction"]), _cache[9] || (_cache[9] = _createElementVNode("div", {
      class: "spacer"
    }, null, -1)), _createVNode(_component_el_dropdown, {
      trigger: "click",
      class: "buttonSubtitle",
      placement: 'bottom-end',
      onCommand: _ctx.onLangSelected
    }, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
        class: "subtitleDropDownMenu"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfSubtitles, subtitle => {
          return _openBlock(), _createBlock(_component_el_dropdown_item, {
            command: subtitle.id,
            disabled: !_ctx.isLangAvailable(subtitle.lang),
            key: 'subtitle' + subtitle.id
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(subtitle.label), 1)]),
            _: 2
          }, 1032, ["command", "disabled"]);
        }), 128)), _createVNode(_component_el_dropdown_item, {
          onClick: _cache[2] || (_cache[2] = $event => _ctx.goToTranscript())
        }, {
          default: _withCtx(() => [_createVNode(_component_icon, {
            icon: "plus"
          }), _createTextVNode(" " + _toDisplayString(_ctx.$t('voiceOver.buttons.addAIVoice')), 1)]),
          _: 1
        })]),
        _: 1
      })]),
      default: _withCtx(() => [_createVNode(_component_standard_button, {
        label: "",
        outlined: true
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.buttons.fromSubtitle')) + " ", 1), _createVNode(_component_icon, {
          icon: "chevron-down",
          class: "iconChevron"
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["onCommand"])])) : _createCommentVNode("", true), _ctx.currentStep == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.langSelected), 1), _createVNode(_component_light_button, {
      class: "labelVoiceSelectedCancel",
      onAction: _cache[3] || (_cache[3] = $event => _ctx.cancelVoiceAI())
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.buttons.cancel')), 1)]),
      _: 1
    }), _createVNode(_component_standard_button, {
      class: "labelVoiceSelectedConfirm",
      onAction: _ctx.confirmVoiceAIOver,
      loading: _ctx.waitingTranscoding,
      disabled: _ctx.waitingTranscoding
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.buttons.confirmVoiceIA')), 1)]),
      _: 1
    }, 8, ["onAction", "loading", "disabled"])])) : _createCommentVNode("", true), _ctx.currentStep == 10 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_light_button, {
      class: "cancelButtonCountDown",
      onAction: _cache[4] || (_cache[4] = $event => _ctx.cancelMicrophoneRecord())
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.buttons.cancel')), 1)]),
      _: 1
    })])) : _createCommentVNode("", true), _ctx.currentStep == 11 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", {
      class: "recordingProgress",
      style: _normalizeStyle(_ctx.progressRecordStyle)
    }, null, 4)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_icon, {
      icon: "record",
      color: "red",
      size: "default"
    }), _createTextVNode(" " + _toDisplayString(_ctx.timeRecordedFormat), 1)]), _cache[10] || (_cache[10] = _createElementVNode("div", {
      class: "spacer"
    }, null, -1)), !_ctx.isRecordingPause ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 0,
      class: "stopPausePlayButton",
      outlined: true,
      onAction: _ctx.pauseMicrophoneRecording,
      disabled: !_ctx.isRecording
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "pause"
      }), _createTextVNode(" " + _toDisplayString(_ctx.$t('voiceOver.record.buttons.pause')), 1)]),
      _: 1
    }, 8, ["onAction", "disabled"])) : _createCommentVNode("", true), _ctx.isRecordingPause ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 1,
      class: "stopPausePlayButton",
      outlined: true,
      onAction: _ctx.resumeMicrophoneRecording,
      disabled: !_ctx.isRecording
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "play"
      }), _createTextVNode(" " + _toDisplayString(_ctx.$t('voiceOver.record.buttons.resume')), 1)]),
      _: 1
    }, 8, ["onAction", "disabled"])) : _createCommentVNode("", true), _createVNode(_component_standard_button, {
      class: "stopPausePlayButton",
      onAction: _ctx.stopMicrophoneRecording,
      disabled: !_ctx.isRecording
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "stop"
      }), _createTextVNode(" " + _toDisplayString(_ctx.$t('voiceOver.record.buttons.stop')), 1)]),
      _: 1
    }, 8, ["onAction", "disabled"])])])) : _createCommentVNode("", true), _ctx.currentStep == 12 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_standard_button, {
      class: "buttonRestart",
      outlined: true,
      onAction: _ctx.onChooseMicVoice
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "record-circle-outline"
      }), _createTextVNode(" " + _toDisplayString(_ctx.$t('voiceOver.record.buttons.restart')), 1)]),
      _: 1
    }, 8, ["onAction"])]), _createVNode(_component_light_button, {
      class: "buttonConfirmMicrophone",
      outlined: true,
      onAction: _ctx.cancelMicrophoneRecord
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.record.buttons.cancel')), 1)]),
      _: 1
    }, 8, ["onAction"]), _createVNode(_component_standard_button, {
      class: "buttonConfirmMicrophone",
      onAction: _ctx.confirmMicRecording,
      disabled: _ctx.waitingTranscoding,
      loading: _ctx.waitingTranscoding
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.record.buttons.confirm')), 1)]),
      _: 1
    }, 8, ["onAction", "disabled", "loading"])])) : _createCommentVNode("", true), _createVNode(_component_MediaRecorder, {
      ref: "mediaRecorder",
      countdown: 3,
      onOnBlobRecorded: _ctx.onSuccessMicrophoneRecorded,
      "with-button": false,
      onOnError: _ctx.onMicrophoneError,
      onOnCountDown: _ctx.onCountDown,
      onOnStart: _ctx.onStartRecording,
      onOnTimeRecord: _ctx.onTimeRecord
    }, null, 8, ["onOnBlobRecorded", "onOnError", "onOnCountDown", "onOnStart", "onOnTimeRecord"]), _ctx.currentStep == 20 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_w_input, {
      type: "textarea",
      class: "textArea",
      placeholder: _ctx.$t('voiceOver.txt.type'),
      modelValue: _ctx.textToGenerate,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.textToGenerate = $event),
      "show-word-limit": true,
      maxlength: 3000
    }, null, 8, ["placeholder", "modelValue"]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_w_select, {
      placeholder: _ctx.$t('voiceOver.txt.voiceSelectPlaceholdler'),
      options: _ctx.listOfLang,
      value: _ctx.listOfLang[0],
      modelValue: _ctx.langTxtSelected,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.langTxtSelected = $event)
    }, null, 8, ["placeholder", "options", "value", "modelValue"])]), _cache[11] || (_cache[11] = _createElementVNode("div", {
      class: "spacer"
    }, null, -1)), !_ctx.loadingVoiceFromText ? (_openBlock(), _createBlock(_component_light_button, {
      key: 0,
      class: "buttonCancelTxtEdition",
      onAction: _ctx.cancelTxtVoiceAI
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.txt.button.cancel')), 1)]),
      _: 1
    }, 8, ["onAction"])) : _createCommentVNode("", true), !_ctx.loadingVoiceFromText ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 1,
      onAction: _ctx.previewVoiceAI,
      outlined: true,
      disabled: !_ctx.langTxtSelected || !_ctx.textToGenerate
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "play"
      }), _createTextVNode(" " + _toDisplayString(_ctx.$t('voiceOver.txt.button.preview')), 1)]),
      _: 1
    }, 8, ["onAction", "disabled"])) : _createCommentVNode("", true), !_ctx.loadingVoiceFromText ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 2,
      onAction: _ctx.confirmTxtVoiceAI,
      class: "confirmButton",
      disabled: !_ctx.urlBlob || _ctx.waitingTranscoding,
      loading: _ctx.waitingTranscoding
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.txt.button.confirm')), 1)]),
      _: 1
    }, 8, ["onAction", "disabled", "loading"])) : (_openBlock(), _createBlock(_component_standard_button, {
      key: 3,
      disabled: true
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.txt.waiting')), 1), _createVNode(_component_loader, {
        "spinner-size": 'spinnersSmall',
        class: "loader",
        "spinner-color": 'lightSpinner'
      })]),
      _: 1
    }))])])) : _createCommentVNode("", true)])])]),
    _: 1
  }, 8, ["visible"])]);
}